import { InputRow, SortableTable, WidgetBlock } from 'hub-web-lib/dist/index-export'
import { getCurrentYear, getGanttColumns, getGanttTableData, getModuleLink, getYears } from 'js/ui-helpers/activity-gantt'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import './ActivityGantt.scss'
import { connect } from 'react-redux'
import { getUserRole } from 'js/ui-helpers/roles'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    }
}

const ActivityGanttComponent = ({ activitiesData = [], title = '', defaultYear = getCurrentYear(), currentUser }) => {
    const [selectedYear, setSelectedYear] = useState(defaultYear)
    const location = useLocation()
    const currentPath = `${location.pathname}${location.search}`
    const navigate = useNavigate()
    const canEditActivity = getUserRole(currentUser) <= 2
    const years = getYears()
    const yearControl = <div className='year-control'>
        <InputRow
            inputId='year-control'
            inputTag='select'
            defaultValue={selectedYear}
            options={years}
            changeValueHandler={setSelectedYear} />
    </div>

    const templateTableColumns = getGanttColumns(selectedYear)

    const tableData = getGanttTableData(
        selectedYear,
        activitiesData
    )

    const ganttClickHandler = (activityData) => {
        navigate(getModuleLink(activityData, canEditActivity, currentPath))
    }

    return (
        !!tableData.length &&
            <div className='widgets-row activites-plan'>
                <WidgetBlock title={title} content={
                    <>
                        {yearControl}
                        <div className={`activites-table ${canEditActivity ? 'all-clickable' : 'only-completed-clickable'}`}>
                            <SortableTable columns={templateTableColumns} tableData={tableData} noFilter={true} customClass='gantt-table' ganttClickHandler={ganttClickHandler} />
                        </div>
                    </>
                } />
            </div>
    )
}
const ActivityGantt = connect(mapStateToProps)(ActivityGanttComponent)
export default ActivityGantt
